<template>
    <modal title-modal="Configuração de Fórmulas" modal-large id-modal="config-formula-modal">
        <template #title>Configuração de Fórmulas</template>
        <div class="modal-body">
            <div class="row">
                <!-- ===================== ÁREA PÚBLICA ===================== -->
                <div class="col-md-6">
                    <div class="card mb-3 soft-card">
                        <div class="card-header d-flex align-items-center justify-content-between card-header--public">
                            <h5 class="mb-0 text-white">Área Pública</h5>
                            <div class="custom-control custom-switch">
                                <input type="checkbox"
                                       class="custom-control-input"
                                       id="switch-public-allow"
                                       :disabled="isDefaultConfig"
                                       :checked="formula_config.public.allow_switch"
                                       @change="toggleAllowSwitch('public', $event.target.checked)">
                                <label class="custom-control-label text-white pointer" for="switch-public-allow">
                                    Permitir troca durante o cálculo
                                </label>
                            </div>
                        </div>
                        <div class="card-body p-0">
                            <div class="table-responsive mb-0">
                                <table class="table table-sm table-bordered table-hover align-middle mb-0">
                                    <thead class="thead-public">
                                    <tr class="text-center">
                                        <th style="min-width: 160px;">Fórmula (Tabela)</th>
                                        <th>Disponível</th>
                                        <th>Default</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    <tr v-for="formula in formulas" :key="'public-' + formula.code">
                                        <td>
                                            <strong>{{ formula.label }}</strong>
                                            <div class="small text-muted">{{ formula.code }}</div>
                                        </td>
                                        <td class="text-center">
                                            <input type="checkbox"
                                                   :checked="isEnabled('public', formula.code)"
                                                   :disabled="isDefaultConfig || isAvailabilityDisabled('public', formula.code)"
                                                   @change="toggleEnabled('public', formula.code, $event.target.checked)">
                                        </td>
                                        <td class="text-center">
                                            <input type="radio"
                                                   name="default-public"
                                                   :value="formula.code"
                                                   :checked="isDefault('public', formula.code)"
                                                   :disabled="isDefaultConfig || !isEnabled('public', formula.code)"
                                                   @change="setDefault('public', formula.code)">
                                        </td>
                                    </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- =================== ÁREA AUTENTICADA ==================== -->
                <div class="col-md-6">
                    <div class="card mb-3 soft-card">
                        <div class="card-header d-flex align-items-center justify-content-between card-header--auth">
                            <h5 class="mb-0 text-white">Área Autenticada</h5>
                            <div class="custom-control custom-switch">
                                <input type="checkbox"
                                       class="custom-control-input"
                                       id="switch-auth-allow"
                                       :disabled="isDefaultConfig"
                                       :checked="formula_config.authenticated.allow_switch"
                                       @change="toggleAllowSwitch('authenticated', $event.target.checked)">
                                <label class="custom-control-label text-white pointer" for="switch-auth-allow">
                                    Permitir troca durante o cálculo
                                </label>
                            </div>
                        </div>
                        <div class="card-body p-0">
                            <div class="table-responsive mb-0">
                                <table class="table table-sm table-bordered table-hover align-middle mb-0">
                                    <thead class="thead-auth">
                                    <tr class="text-center">
                                        <th style="min-width: 160px;">Fórmula (Tabela)</th>
                                        <th>Disponível</th>
                                        <th>Default</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    <tr v-for="formula in formulas" :key="'auth-' + formula.code">
                                        <td>
                                            <strong>{{ formula.label }}</strong>
                                            <div class="small text-muted">{{ formula.code }}</div>
                                        </td>
                                        <td class="text-center">
                                            <input type="checkbox"
                                                   :checked="isEnabled('authenticated', formula.code)"
                                                   :disabled="isDefaultConfig || isAvailabilityDisabled('authenticated', formula.code)"
                                                   @change="toggleEnabled('authenticated', formula.code, $event.target.checked)">
                                        </td>
                                        <td class="text-center">
                                            <input type="radio"
                                                   name="default-authenticated"
                                                   :value="formula.code"
                                                   :checked="isDefault('authenticated', formula.code)"
                                                   :disabled="isDefaultConfig || !isEnabled('authenticated', formula.code)"
                                                   @change="setDefault('authenticated', formula.code)">
                                        </td>
                                    </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="modal-footer" style="justify-content: space-between">
            <div>
                <h5 class="ml-3 font-italic" style="font-size: .7rem;">É preciso atualizar as páginas do simulador
                    abertas antes do update.</h5>
            </div>
            <div>
                <div class="btn btn-secondary" @click="closeModal">{{ t('ACTIONS.CLOSE') }}</div>
                <div class="btn btn-primary ml-2" @click="save">{{ t('ACTIONS.SAVE') }}</div>
            </div>
        </div>
    </modal>
</template>

<script>

import {useI18n} from 'vue-i18n';
import Enum from '@/enums/SimulatorEnum';
import modal from '@/components/modal.vue';
import {useToast} from 'vue-toastification';

export default {
    name: 'configFormulaComponent',
    components: {
        modal,
    },
    emits: ['updateFormula'],
    setup() {
        const {t} = useI18n();
        const toast = useToast();

        return {t, toast};
    },
    computed: {
        isDefaultConfig() {
            return this.$route.params.id === '1';
        }
    },
    data() {
        return {
            formulas: [
                {code: Enum.price, label: Enum.priceLabel},
                {code: Enum.sacocSimple, label: Enum.sacocSimpleLabel},
                {code: Enum.sacocCompound, label: Enum.sacocCompoundLabel},
            ],
            formula_config: {
                public: {allow_switch: false, formulas: [Enum.price], default: Enum.price},
                authenticated: {allow_switch: false, formulas: [Enum.price], default: Enum.price},
            },
        };
    },
    methods: {
        setFormulaConfig(formulaConfig) {
            this.formula_config = formulaConfig ? formulaConfig : {
                public: {allow_switch: false, formulas: [Enum.price], default: Enum.price},
                authenticated: {allow_switch: false, formulas: [Enum.price], default: Enum.price},
            };
        },
        isEnabled(area, code) {
            return this.formula_config[area].formulas.includes(code);
        },
        isDefault(area, code) {
            return this.formula_config[area].default === code;
        },
        isAvailabilityDisabled(area, code) {
            const a = this.formula_config[area];
            const isLastEnabled = a.formulas.length === 1 && a.formulas[0] === code;
            return !a.allow_switch || isLastEnabled;
        },
        toggleEnabled(area, code, checked) {
            const a = this.formula_config[area];
            if (!a.allow_switch) {
                this.toast?.info('Troca bloqueada nesta área.');
                return;
            }
            const set = new Set(a.formulas);
            if (checked) {
                set.add(code);
            } else {
                if (set.size === 1 && set.has(code)) {
                    this.toast?.warning('Deve haver pelo menos um método habilitado.');
                    return;
                }
                set.delete(code);
                if (a.default === code) {
                    a.default = Array.from(set)[0];
                }
            }
            a.formulas = Array.from(set);
        },
        closeModal() {
            document.getElementById('closeX')?.click();
        },
        setDefault(area, code) {
            const a = this.formula_config[area];
            a.default = code;
            if (!a.formulas.includes(code)) a.formulas.unshift(code);
            if (!a.allow_switch) a.formulas = [code];
        },
        toggleAllowSwitch(area, allowed) {
            const a = this.formula_config[area];
            a.allow_switch = allowed;
            if (!allowed) {
                if (!a.formulas.includes(a.default)) a.formulas.unshift(a.default);
                a.formulas = [a.default];
            }
        },
        save() {
            if (this.$route.params.action !== 'adicionar') {
                this.$swal.fire({
                    title: 'Tem Certeza?',
                    text: 'Esta ação é irreversível',
                    icon: 'question',
                    showCancelButton: true,
                    showCloseButton: false,
                    confirmButtonText: 'Atualizar',
                    cancelButtonText: 'Cancelar',
                }).then(result => {
                    if (result.isConfirmed) this.$emit('updateFormula', this.formula_config);
                });
            } else this.$emit('updateFormula', this.formula_config);
        },
    },
};

</script>

<style scoped>
/* Cores das áreas */
.card-header--public {
    background-color: #0e5e4e; /* verde */
    color: #fff;
}

.card-header--auth {
    background-color: #295da0; /* azul */
    color: #fff;
}

/* Títulos e labels brancos no header colorido */
.card-header--public .custom-control-label,
.card-header--auth .custom-control-label {
    color: #fff;
}

/* Cabeçalhos das tabelas com a mesma paleta */
.thead-public th {
    background-color: rgba(14, 94, 78, 0.9);
    color: #fff;
    border-color: rgba(14, 94, 78, 0.95);
}

.thead-auth th {
    background-color: rgba(41, 93, 160, 0.9);
    color: #fff;
    border-color: rgba(41, 93, 160, 0.95);
}

/* Toques de refinamento */
.soft-card {
    border: 1px solid rgba(0, 0, 0, .06);
    box-shadow: 0 2px 10px rgba(0, 0, 0, .04);
}

.table thead th {
    vertical-align: middle;
}

.table td, .table th {
    padding: .6rem .75rem;
}

.table-hover tbody tr:hover {
    background-color: rgba(0, 0, 0, .035);
}

/* Melhor visibilidade do switch em header escuro (opcional) */
.card-header--public .custom-control-input:checked ~ .custom-control-label::before,
.card-header--auth .custom-control-input:checked ~ .custom-control-label::before {
    border-color: #fff;
}

.card-header--public .custom-control-label::before,
.card-header--auth .custom-control-label::before {
    background-color: rgba(255, 255, 255, 0.15);
    border-color: rgba(255, 255, 255, 0.35);
}

</style>
